import { peekSensorFieldChange } from '@Actions/sensorDetails';
import { getValue } from '@Selectors/common.selectors';
import { SensorConfigFormShape } from '@Types/configurations.types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

type ConnectionPeekReturn = {
	peekQuery: string;
};

export const useConnectionPeek = (
	formData: SensorConfigFormShape,
): ConnectionPeekReturn => {
	const dispatch = useDispatch();
	const {
		editSensorData: {
			peek: { query: peekQuery },
		},
	} = useSelector(getValue);

	useEffect(() => {
		dispatch(peekSensorFieldChange(formData));
	}, [
		formData.sensorId,
		formData.sensorTable,
		formData.sensorIdField,
		formData.tagValue,
		formData.sensorDateField,
		formData.sensorChannelField,
		formData.dataSourceId,
		formData.collectionInterval,
	]);

	return { peekQuery };
};
